// extracted by mini-css-extract-plugin
module.exports = {"WrapperOtherPosts":"RYGF","WrapperOtherPosts_debug":"LRtq"};